var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageDefaultNoFood(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M500 0H0V500H500V0Z",
    fill: "#E7E9F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M371.886 180C353.596 180 338.773 194.824 338.773 213.114C338.773 262.249 298.952 302.224 250 302.224C201.048 302.224 161.227 262.249 161.227 213.114C161.227 194.824 146.404 180 128.114 180C109.824 180 95 194.824 95 213.114C95 298.899 164.398 368.452 250 368.452C335.602 368.452 405 298.913 405 213.114C405 194.824 390.176 180 371.886 180V180Z",
    fill: "#C5CBEB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageDefaultNoFood);
export default __webpack_public_path__ + "static/media/image-default-no-food.984748b8.svg";
export { ForwardRef as ReactComponent };